import script from "./HrPopupEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPopupEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupEdit});
